// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const SingleDiscriminatedUnionType = {
    samePropertiesAsObject: (value) => {
        return Object.assign(Object.assign({}, value), { type: "samePropertiesAsObject", _visit: function (visitor) {
                return FernIr.dynamic.SingleDiscriminatedUnionType._visit(this, visitor);
            } });
    },
    singleProperty: (value) => {
        return Object.assign(Object.assign({}, value), { type: "singleProperty", _visit: function (visitor) {
                return FernIr.dynamic.SingleDiscriminatedUnionType._visit(this, visitor);
            } });
    },
    noProperties: (value) => {
        return Object.assign(Object.assign({}, value), { type: "noProperties", _visit: function (visitor) {
                return FernIr.dynamic.SingleDiscriminatedUnionType._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "samePropertiesAsObject":
                return visitor.samePropertiesAsObject(value);
            case "singleProperty":
                return visitor.singleProperty(value);
            case "noProperties":
                return visitor.noProperties(value);
            default:
                return visitor._other(value);
        }
    },
};
